import React from 'react'
import styled from 'styled-components'

export default ({
  placeholder,
  type,
  disabled,
  value = '',
  onChange = undefined,
  ...args
}) => {
  const [internalValue, setInternalValue] = React.useState('')
  const [focused, setFocused] = React.useState(false)

  const change = React.useCallback(event => {
    onChange && onChange(event)
    setInternalValue(event.target.value)
  }, [setInternalValue, onChange])

  const onFocus = React.useCallback(() => {
    setFocused(true)
  }, [setFocused])

  const onBlur = React.useCallback(() => {
    setFocused(false)
  }, [setFocused])

  const inputClass = React.useMemo(() => {
    const classes = []

    focused && classes.push('focused')
    internalValue.length > 0 && classes.push('has-content')

    return classes.join(' ')
  }, [internalValue, focused])

  // Reference

  const placeholderReference = React.useRef(null)

  const paddingLeft = React.useMemo(() => {
    const elm = placeholderReference.current

    if (elm === null) {
      return 17
    }

    const style = elm.currentStyle || window.getComputedStyle(elm)

    return focused
      ? 17
      : parseFloat(elm.offsetWidth) + parseFloat(style.marginRight) + 17

  }, [focused, internalValue, placeholderReference])

  React.useLayoutEffect(() => {
    setInternalValue(value)
  }, [value, setInternalValue])

  const style = args.style || {}

  // Check for disabled

  React.useEffect(() => {
    setFocused(false)
  }, [disabled, setFocused])

  return (
    <Wrapper className={inputClass}>
      {placeholder !== undefined && (
        <Placeholder ref={placeholderReference}>{placeholder}</Placeholder>
      )}

      <input type={type}
             value={internalValue}
             onChange={change}
             onFocus={onFocus}
             onBlur={onBlur}
             style={{...style, paddingLeft}}
             disabled={disabled}
             {...args}
      />
    </Wrapper>
  )
}

const Placeholder = styled.div`
  color: rgba(59, 50, 51, 0.5);
  font-weight: 700;
  position: absolute;
  top: 50%;
  left: 18px;
  transform: translateY(-50%);
  font-size: 13px;
  font-family: 'Lato', sans-serif;
  pointer-events: none;
  transition: all 2.5s;
  margin-right: 13px;
  letter-spacing: 0.25px;
`

const Wrapper = styled.div`
  position: relative;
  margin-bottom: 20px;
  
  input {
    width: 100%;
    background: #f5f5f5;
    border: 0;
    height: 50px;
    border-radius: 50px;
    border: 2px solid transparent;
    transition: all .5s;
    padding: 0 16px;
    font-family: 'Lato', sans-serif;
    font-weight: 200;
    color: #000;
    letter-spacing: 0.5px;
    
    &:disabled {
      opacity: 0.5;
    }
  }
  
  &.focused {
    input{
      border: 2px solid #87797b;
      box-shadow: 0 0 39px 0 #f4efef !important;
    }
    
    ${Placeholder} {
      transition: all .5s;
    }
  }
  
  &.has-content, &.focused {
    ${Placeholder} {
      color: rgba(59, 50, 51, 1);
    }
  }
  
  &.has-content.focused {
    ${Placeholder} {
      opacity: 0;
    }
  }
`
